/**
 * UI-facing label maps for fulfillment statuses + flag modes. Kept in the
 * module (not @pc/db) so the operator-facing copy stays close to the
 * components that render it.
 */
import type {
  FulfillmentShipmentStatus,
  FulfillmentPackingFlagMode,
} from '@pc/db';

export const SHIPMENT_STATUS_LABELS: Record<FulfillmentShipmentStatus, string> = {
  needs_label: 'Needs label',
  ready_to_pack: 'Ready to pack',
  packed: 'Packed',
  in_transit: 'In transit',
  out_for_delivery: 'Out for delivery',
  available_for_pickup: 'Ready for pickup',
  delayed: 'Delayed',
  delivered: 'Delivered',
  exception: 'Exception',
  return_to_sender: 'Return to sender',
  lost: 'Lost',
  investigation: 'Investigation',
  cancelled: 'Cancelled',
  on_hold: 'On hold',
};

// Tailwind-friendly chip classes. Mirrors @pc/modules-orders/components/StatusChip.tsx
// palette tokens so the queue page reads as part of the same product.
export const SHIPMENT_STATUS_CLASSES: Record<FulfillmentShipmentStatus, string> = {
  needs_label: 'border-rule text-ink-2 bg-paper-2',
  ready_to_pack: 'border-clay/40 text-clay bg-clay/10',
  packed: 'border-olive/40 text-olive bg-olive/10',
  in_transit: 'border-olive/40 text-olive bg-olive/10',
  out_for_delivery: 'border-olive/40 text-olive bg-olive/10',
  available_for_pickup: 'border-olive/40 text-olive bg-olive/10',
  delayed: 'border-clay/40 text-clay bg-clay/10',
  delivered: 'border-olive text-olive bg-olive/15',
  exception: 'border-clay text-clay bg-clay/15',
  return_to_sender: 'border-clay text-clay bg-clay/15',
  lost: 'border-clay text-clay bg-clay/15',
  investigation: 'border-clay text-clay bg-clay/15',
  cancelled: 'border-rule text-muted bg-paper-2',
  on_hold: 'border-rule text-muted bg-paper-2',
};

export const FLAG_MODE_LABELS: Record<FulfillmentPackingFlagMode, string> = {
  required: 'Required',
  optional: 'Optional',
  disabled: 'Disabled',
};

export const PEPTIDE_FLAG_LABELS = {
  was_reconstituted: 'Reconstituted before shipping',
  included_needles: 'Included needles / supplies',
  shipped_with_ice_pack: 'Shipped with ice pack',
} as const;
export type PeptideFlagKey = keyof typeof PEPTIDE_FLAG_LABELS;
